class CsvExportService {
  /**
   * Passes in tableData object and returns a CSV string
   */
  mapChartDataToCsv (tableData) {
    const headers = tableData.columns.map((column) => column.label)
    const rows = tableData.rows.map((row) => {
      const columnValues = row.columns.map((column) => {
        if (column.parts && column.parts.length > 0 && column.parts[0].values && column.parts[0].values.length > 0) {
          return column.parts[0].values[0]
        } else {
          return ''
        }
      })
      return [row.label, ...columnValues]
    })

    return this.toCsv([headers, ...rows])
  }

  /**
   * Converts an array of arrays into CSV format and handles commas and backspaces,
   * if they were to appear in the dataset
   */
  toCsv (rows) {
    const csvRows = rows.map((row) => {
      return row.map((value) => {
        if (value === null || value === undefined) {
          value = ''
        }
        value = value.toString()

        // Escape backslashes in the data
        value = value.replace(/\\/g, '\\\\')

        // Escape double quotes in the data
        value = value.replace(/"/g, '\\"')

        // Wrap the value in double quotes
        return `"${value}"`
      }).join(',')
    })

    return csvRows.join('\r\n')
  }
}

export const csvExportService = new CsvExportService()
